<template>
    <div class="form-type-0">
        <form @submit.prevent="updatePersonalia" @input="onInputChange" ref="form" novalidate>
            <CustomInput
                v-model="name"
                inputKey="user_name"
                type="text"
                ref="name"
                autocomplete="name"
                :cssClass="hideSaveButton ? 'hide-label' : ''"
                required
            />

            <button v-if="!hideSaveButton || hasChanged" type="submit" :disabled="loading">
                <span v-if="loading" class="loading-spinner-type-1"></span>
                <span v-else>{{ $t('forms.personalia.button') }}</span>
            </button>
            <p v-if="formError" class="form-error">{{ $t('forms.personalia.error') }}</p>
            <p v-if="formSuccess" class="form-success">{{ $t('forms.personalia.success') }}</p>
        </form>
    </div>
</template>

<script>
    import { useUserStore } from '@/stores/user';
    import CustomInput from '@/components/elements/inputs/CustomInput';
    import formMixin from '@/mixins/formMixin'

    export default {
        mixins: [formMixin],
        props: {
            hideSaveButton: {
                type: Boolean,
                default: false
            }
        },
        components: {
            CustomInput
        },
        data() {
            return {
                name: ''
            };
        },
        computed: {
            userStore() {
                return useUserStore();
            }
        },
        created() {
            this.name = this.userStore.user.name;
        },
        methods: {
            async updatePersonalia() {
                const form = this.$refs.form;
                if(form.checkValidity()) {
                    this.loading = true;
                    const success = await this.userStore.updatePersonalia({
                        name: this.name
                    });
                    this.loading = false;

                    if (success) {
                        this.formSuccess = true;
                        this.formError = false;
                        this.hasChanged = false;
                    } else {
                        this.formSuccess = false;
                        this.formError = true;
                    }

                } else {
                    this.validateAllFields();
                }
            }
        }
    }
</script>
